import AppLogoIcon from './app-logo-icon';
import { usePage } from '@inertiajs/react';
import type { SharedData } from '@/types';

export default function AppLogo() {
    const { name } = usePage<SharedData>().props;

    return (
        <>
            <div className="mb-1 flex h-9 w-9 items-center justify-center rounded-md">
                <AppLogoIcon className="size-9 fill-current text-[var(--foreground)] dark:text-white" />
            </div>
            <div className="ml-1 grid flex-1 text-left text-sm">
                <span className="mb-0.5 truncate leading-none font-semibold">{name}
                    <span
                        className="bg-yellow-100 text-black text-xs font-medium ml-1 me-2 px-2.5 py-0.5 rounded-sm dark:bg-yellow-900 dark:text-white">Beta</span>
                </span>
            </div>
        </>
    );
}
